<script setup lang="ts">
// Vue & Plugins
import { computed } from 'vue'

// Components
import FormTextInput from './FormTextInput.vue'

// data
defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  modelValue: string
  id: string
  label: string
}>()
const emit = defineEmits(['update:modelValue'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})
</script>

<template>
  <span
    class="p-float-label mt-1"
  >
    <FormTextInput
      v-bind="$attrs"
      :id="id"
      v-model="value"
    />
    <label :for="id">{{ label }}</label>
  </span>
</template>
